export default "__VITE_ASSET__B9MRt9N$__"